import { render } from "./ProductCarrierForm.vue?vue&type=template&id=46cd0e3c"
import script from "./ProductCarrierForm.vue?vue&type=script&lang=js"
export * from "./ProductCarrierForm.vue?vue&type=script&lang=js"

import "./ProductCarrierForm.vue?vue&type=style&index=0&id=46cd0e3c&lang=scss"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__